import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { rotate } from '@tonaljs/collection';
import { deprecate, transpose } from '@tonaljs/core';
import { simplify, transposeFifths } from '@tonaljs/interval';
import { EmptyPcset, chromaToIntervals } from '@tonaljs/pcset';
var MODES = [[0, 2773, 0, "ionian", "", "Maj7", "major"], [1, 2902, 2, "dorian", "m", "m7"], [2, 3418, 4, "phrygian", "m", "m7"], [3, 2741, -1, "lydian", "", "Maj7"], [4, 2774, 1, "mixolydian", "", "7"], [5, 2906, 3, "aeolian", "m", "m7", "minor"], [6, 3434, 5, "locrian", "dim", "m7b5"]];

var NoMode = _objectSpread(_objectSpread({}, EmptyPcset), {}, {
  name: "",
  alt: 0,
  modeNum: NaN,
  triad: "",
  seventh: "",
  aliases: []
});

var modes = MODES.map(toMode);
var index = {};
modes.forEach(function (mode) {
  index[mode.name] = mode;
  mode.aliases.forEach(function (alias) {
    index[alias] = mode;
  });
});
/**
 * Get a Mode by it's name
 *
 * @example
 * get('dorian')
 * // =>
 * // {
 * //   intervals: [ '1P', '2M', '3m', '4P', '5P', '6M', '7m' ],
 * //   modeNum: 1,
 * //   chroma: '101101010110',
 * //   normalized: '101101010110',
 * //   name: 'dorian',
 * //   setNum: 2902,
 * //   alt: 2,
 * //   triad: 'm',
 * //   seventh: 'm7',
 * //   aliases: []
 * // }
 */

function get(name) {
  return typeof name === "string" ? index[name.toLowerCase()] || NoMode : name && name.name ? get(name.name) : NoMode;
}

var mode = deprecate("Mode.mode", "Mode.get", get);
/**
 * Get a list of all modes
 */

function all() {
  return modes.slice();
}

var entries = deprecate("Mode.mode", "Mode.all", all);
/**
 * Get a list of all mode names
 */

function names() {
  return modes.map(function (mode) {
    return mode.name;
  });
}

function toMode(mode) {
  var _mode = _slicedToArray(mode, 7),
      modeNum = _mode[0],
      setNum = _mode[1],
      alt = _mode[2],
      name = _mode[3],
      triad = _mode[4],
      seventh = _mode[5],
      alias = _mode[6];

  var aliases = alias ? [alias] : [];
  var chroma = Number(setNum).toString(2);
  var intervals = chromaToIntervals(chroma);
  return {
    empty: false,
    intervals: intervals,
    modeNum: modeNum,
    chroma: chroma,
    normalized: chroma,
    name: name,
    setNum: setNum,
    alt: alt,
    triad: triad,
    seventh: seventh,
    aliases: aliases
  };
}

function notes(modeName, tonic) {
  return get(modeName).intervals.map(function (ivl) {
    return transpose(tonic, ivl);
  });
}

function chords(chords) {
  return function (modeName, tonic) {
    var mode = get(modeName);
    if (mode.empty) return [];
    var triads = rotate(mode.modeNum, chords);
    var tonics = mode.intervals.map(function (i) {
      return transpose(tonic, i);
    });
    return triads.map(function (triad, i) {
      return tonics[i] + triad;
    });
  };
}

var triads = chords(MODES.map(function (x) {
  return x[4];
}));
var seventhChords = chords(MODES.map(function (x) {
  return x[5];
}));

function distance(destination, source) {
  var from = get(source);
  var to = get(destination);
  if (from.empty || to.empty) return "";
  return simplify(transposeFifths("1P", to.alt - from.alt));
}

function relativeTonic(destination, source, tonic) {
  return transpose(tonic, distance(destination, source));
}

var index$1 = {
  get: get,
  names: names,
  all: all,
  distance: distance,
  relativeTonic: relativeTonic,
  notes: notes,
  triads: triads,
  seventhChords: seventhChords,
  // deprecated
  entries: entries,
  mode: mode
};
export default index$1;
export { all, distance, entries, get, mode, names, notes, relativeTonic, seventhChords, triads };